import axios from 'axios';

export default class PublicService {
  public getLocationByIp(ipAddress: string) {
    return axios.get('api/public/getLocationByIp/' + ipAddress);
  }

  previewInfoByUrl(url: string, connectomeId?: string) {
    return axios.get('api/public/previewByUrl?url='.concat(url).concat('&connectomeId=').concat(connectomeId));
  }

  previewInfoByUrlV3(payload) {
    return axios.post('api/public/previewByUrl-v3', payload);
  }

  getIpFromClient() {
    return new Promise(resolve => {
      $.getJSON('https://api.ipify.org/?format=json', data => {
        resolve(data.ip);
      });
    });
  }

  public getCountryCode() {
    return axios.get('api/public/getCountryCode');
  }
}
